export class Modifier {
  public modifiingValueName: string;
  public modifiingValue: number;
  public source: string;

  public constructor(valueName: string, value: number, source: string) {
    this.modifiingValueName = valueName;
    this.modifiingValue = value;
    this.source = source;
  }
}
